__turbopack_context__.v({
  "channels": "xmkSba_channels",
  "container": "xmkSba_container",
});
